import {Module} from '@gongxigames/framework/slot/fragments/module/Module';
import {GlobalEventsMapForBackwardCompatibility} from '@gongxigames/framework/slot/events';
import {PromotionCounterView} from '@gongxigames/framework/slot/modules/promotionsCounter/PromotionCounterView';
import {PromotionCounterBasicState} from '@gongxigames/framework/slot/modules/promotionsCounter/states/PromotionCounterBasicState';
import {PromotionCounterActiveState} from '@gongxigames/framework/slot/modules/promotionsCounter/states/PromotionCounterActiveState';

export class PromotionCounterModule extends Module<PromotionCounterView, GlobalEventsMapForBackwardCompatibility> {
    public static readonly NAME: symbol = Symbol('PromotionCounterModule');
    public static readonly BASIC_STATE: string = 'basic';
    public static readonly ACTIVE_STATE: string = 'active';


    protected setupEvents(): void {
        super.setupEvents();

        this.onCurrentStateHandle('General.Promotion.ActivateCounter');
        this.onCurrentStateHandle('General.Promotion.DeactivateCounter');
        this.onCurrentStateHandle('General.Promotion.ShowCounter');
        this.onCurrentStateHandle('General.Promotion.UpdateCounter');
        this.onCurrentStateHandle('General.Promotion.HideCounter');

        // this.onCurrentStateHandle(MenuBarEvents.CLOSED);
        this.onCurrentStateHandle('UI.menu.closed');
        this.onCurrentStateHandle('UI.menu.opened');
        this.onCurrentStateHandle('UI.menu.gameRulesClicked');
        this.onCurrentStateHandle('UI.menu.infoPageClicked');
    }

    protected setupViews(): void {
        this.setView(PromotionCounterView.NAME);
    }

    protected setupStates(): void {
        this.addState(new PromotionCounterBasicState(this, PromotionCounterModule.BASIC_STATE));
        this.addState(new PromotionCounterActiveState(this,PromotionCounterModule.ACTIVE_STATE));

        this.gotoState(PromotionCounterModule.BASIC_STATE);
    }
}
